/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadOperatingLicense$Params {
  merchantId: string;
  siteId: string;
      body?: {
'file': Blob;
}
}

export function uploadOperatingLicense(http: HttpClient, rootUrl: string, params: UploadOperatingLicense$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, uploadOperatingLicense.PATH, 'put');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.path('siteId', params.siteId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

uploadOperatingLicense.PATH = '/merchants/{merchantId}/sites/{siteId}/operating-license';
